import { ComponentStyleConfig } from "@chakra-ui/react";

export const Button: ComponentStyleConfig = {
  baseStyle: {
    fontStyle: "bold",
  },
  variants: {
    primary: {
      bg: "brand.altblue",
      color: "white",
      boxShadow: "md",
      _hover: {
        bg: "brand.darkblue",
      },
    },
    secondary: {
      bg: "white",
      color: "brand.altblue",
      borderColor: "brand.altblue",
      borderWidth: "2px",
      boxShadow: "md",
      _hover: {
        bg: "brand.lightblue",
      },
    },
    danger: {
      bg: "red.500",
      color: "white",
      _hover: {
        bg: "red.600",
      },
    },
    tertiary: {
      bg: "transparent",
      color: "brand.darkblue",
      textDecoration: "underline",
    },
  },
  defaultProps: {
    size: "lg",
  },
};
